(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name missingEtsReport.controller:MissingEtsReportCtrl
   *
   * @description
   *
   */
  angular
    .module('missingEtsReport')
    .controller('MissingEtsReportCtrl', MissingEtsReportCtrl);

  function MissingEtsReportCtrl(CommonMasterData,$sce,CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'MissingEtsReportCtrl';

    vm.model = {
      searchPanelToggle : true,
      searchCriteria : {
        fromDate : null,
        toDate : null,
        fromTime : '00:00',
        toTime : '23:59',
        origin: null,
        destination :null,
        carriers: []

      },
      masterList : {
        airportList:[],
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false,
        fromDateAfterToDate : false,
        fromTimeInvalid : false,
        toTimeInvalid : false,
        carriers: []
      },
      initialSearchDone : false,
      reportDataURL : null,
      reportServerBaseUrl : null
    };

    vm.clickOnSearch = function() {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    // vm.submitSearch = function(params) {
    //   missingEtsReport(params);
    // };

    // submit search
    vm.submitSearch = function(params) {
      searchMissingETSReport(params);
    };

    // when change field in search
    vm.changeSearchField = function(searchParams, flag) {
      setDateValidationFlags();
      // if from date time before to date time
      if (!!vm.model.searchCriteria.fromDate
        && !!vm.model.searchCriteria.fromTime
        && !!vm.model.searchCriteria.toDate
        && !!vm.model.searchCriteria.toTime
        && !vm.model.masterList.fromDateFormatInvalid
        && !vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromTimeInvalid
        && !vm.model.masterList.toTimeInvalid
        && !isFromDateBeforeToDate()) {
        vm.model.masterList.fromDateAfterToDate = true;
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }
    };

    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }
      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
      // if from time invalid
      if (!isValidTime(vm.model.searchCriteria.fromTime)) {
        vm.model.masterList.fromTimeInvalid = true;
      } else {
        vm.model.masterList.fromTimeInvalid = false;
      }
      // if from time invalid
      if (!isValidTime(vm.model.searchCriteria.toTime)) {
        vm.model.masterList.toTimeInvalid = true;
      } else {
        vm.model.masterList.toTimeInvalid = false;
      }
    }

    // check from date and to date
    function isFromDateBeforeToDate() {
      return moment(
        vm.model.searchCriteria.fromDate + " "
        + vm.model.searchCriteria.fromTime,
        "DD/MM/YYYY HH:mm").isBefore(
        moment(vm.model.searchCriteria.toDate + " "
          + vm.model.searchCriteria.toTime,
          "DD/MM/YYYY HH:mm"));
    };
    // validate Date
    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    // search Flight Block Time report
    function searchMissingETSReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;
        var reportDesign = "missing_ets_data.rptdesign";

        var url = CommonLogicService.getReportUrl(reportDesign,
          getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    }

    function isValidSearchParams(params) {
      setDateValidationFlags();
      // if date invalid
      if (!!vm.model.searchCriteria.fromDate
        && !!vm.model.searchCriteria.fromTime
        && !!vm.model.searchCriteria.toDate
        && !!vm.model.searchCriteria.toTime) {
        if (vm.model.masterList.toDateFormatInvalid
          || vm.model.masterList.fromTimeInvalid
          || vm.model.masterList.fromDateFormatInvalid
          || vm.model.masterList.toTimeInvalid
          || vm.model.masterList.fromDateAfterToDate) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    }
    // set search param map
    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
      searchParamMap["fromTime"] = param.fromTime;
      searchParamMap["toTime"] = param.toTime;

      if (!!param.origin && !!param.origin.airPortCode) {
        searchParamMap["fromAirport"] = param.origin.airPortCode;
      }

      if (!!param.destination && !!param.destination.airPortCode) {
        searchParamMap["toAirport"] = param.destination.airPortCode;
      }

      searchParamMap["carrier"] = '';
      if (!!param.carriers && !!param.carriers.code) {
        searchParamMap["carrier"] = param.carriers.code;
      }

      return searchParamMap;
    }
    // validate time
    function isValidTime(time) {
      var regex = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/;
      return regex.test(time);
    };


    (function loadAirportList() {
      CommonMasterData.getAirportList(
        function (airports) {
          vm.model.masterList.airportList = airports;
        },
        function () {
          console.log('origin/Destination Airport retrieval error');
        }
      );

      CommonMasterData.searchCarriers(
        function (response) {
          for(var index in response.hubCodes) {
            vm.model.masterList.carriers.push({"code":response.hubCodes[index],"name":response.hubCodes[index]});
          }
          vm.model.defaultCarrier = response.clientCode;
        },
        function (error) {
          MessageService.error(error);
        }
      );

    })();


  }
}());
